export default __webpack_public_path__ + "static/media/applications_photo.ed28fa07.jpg";